module.exports = __webpack_public_path__ + "static/media/gaelens_1.8e107600.jpg";